
import { defineComponent } from "vue";
import LandingPageCirculoSection from "./LandingPageCirculoSection.vue";

export default defineComponent({
  name: "AboutView",
  components: { LandingPageCirculoSection }
});
